/* Propuesta NOX — scroll effects (robust: no rAF dependency for reveals) */
(function(){
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var progress = document.querySelector('.progress');
  var topbar = document.querySelector('.topbar');
  var hero = document.querySelector('.hero');

  function scrollTop(){
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  }

  function onScroll(){
    var h = document.documentElement;
    var max = h.scrollHeight - h.clientHeight;
    var y = scrollTop();
    if(progress) progress.style.width = (max > 0 ? (y/max*100) : 0).toFixed(2) + '%';
    if(topbar && hero){
      topbar.classList.toggle('show', y > (hero.offsetHeight * 0.7));
    }
  }

  /* counters (rAF for smoothness; degrades to final value if rAF is unavailable) */
  function runCount(el){
    var target = parseFloat(el.getAttribute('data-count'));
    var prefix = el.getAttribute('data-prefix') || '';
    var suffix = el.getAttribute('data-suffix') || '';
    var dec = (target % 1 !== 0) ? 1 : 0;
    el.textContent = prefix + target.toFixed(dec) + suffix; // safe final
    if(reduce || typeof requestAnimationFrame !== 'function') return;
    var dur = 1500, start = null;
    function step(ts){
      if(!start) start = ts;
      var t = Math.min((ts-start)/dur, 1);
      var eased = 1 - Math.pow(1-t, 3);
      el.textContent = prefix + (target*eased).toFixed(dec) + suffix;
      if(t<1) requestAnimationFrame(step);
      else el.textContent = prefix + target.toFixed(dec) + suffix;
    }
    el.textContent = prefix + '0' + suffix;
    requestAnimationFrame(step);
  }

  function runBars(container){
    var bars = container.querySelectorAll('.bar');
    for(var i=0;i<bars.length;i++){
      (function(bar, idx){
        setTimeout(function(){ bar.style.width = (bar.getAttribute('data-w')||'40') + '%'; }, 100 + idx*110);
      })(bars[i], i);
    }
  }

  function checkReveal(){
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var nodes = document.querySelectorAll('.reveal:not(.in), .clip:not(.in), [data-count]:not(.counted), .ranking:not(.ranked)');
    for(var i=0;i<nodes.length;i++){
      var el = nodes[i];
      var r = el.getBoundingClientRect();
      if(r.top < vh*0.92 && r.bottom > -60){
        el.classList.add('in');
        if(el.hasAttribute('data-count') && !el.classList.contains('counted')){ el.classList.add('counted'); runCount(el); }
        if(el.classList.contains('ranking') && !el.classList.contains('ranked')){ el.classList.add('ranked'); runBars(el); }
      }
    }
  }

  function parallax(){
    if(reduce) return;
    var vh = window.innerHeight;
    var pxEls = document.querySelectorAll('[data-parallax]');
    for(var i=0;i<pxEls.length;i++){
      var el = pxEls[i];
      var r = el.getBoundingClientRect();
      var off = (r.top + r.height/2 - vh/2) / vh;
      var speed = parseFloat(el.getAttribute('data-parallax')) || 0.12;
      el.style.transform = 'translate3d(0,' + (off * speed * 100).toFixed(1) + 'px,0)';
    }
  }

  function frame(){ onScroll(); checkReveal(); parallax(); }

  var started = false;
  function initEffects(){
    if(started) return; started = true;

    // hero intro — set synchronously so it is never stuck hidden
    if(hero){
      hero.classList.add('ready');
      var spans = hero.querySelectorAll('h1 .ln span');
      for(var i=0;i<spans.length;i++){ spans[i].style.transform = 'none'; }
    }

    window.addEventListener('scroll', frame, {passive:true});
    window.addEventListener('resize', frame, {passive:true});

    frame();
    setTimeout(frame, 120);
    setTimeout(frame, 400);
    setTimeout(frame, 900);
  }

  window.__proposalStart = initEffects;
  if(!document.getElementById('gate') || document.documentElement.classList.contains('pre-unlocked')){
    initEffects();
  }
  window.addEventListener('load', function(){ if(started) frame(); });
})();


/* ===== Access gate (cod 2008) ===== */

(function(){
  var CODE = '2008';
  var root = document.documentElement;
  var gate = document.getElementById('gate');

  function start(){ if(window.__proposalStart) window.__proposalStart(); }

  // already unlocked this session
  if(root.classList.contains('pre-unlocked')){ if(gate) gate.remove(); start(); return; }

  var otp = document.getElementById('otp');
  var msg = document.getElementById('gateMsg');
  var inputs = Array.prototype.slice.call(otp.querySelectorAll('input'));

  function value(){ return inputs.map(function(i){return i.value;}).join(''); }

  function unlock(){
    try{ sessionStorage.setItem('nox_unlocked','1'); }catch(e){}
    root.classList.remove('locked');
    gate.classList.add('open');
    start();
    setTimeout(function(){ if(gate) gate.remove(); }, 720);
  }

  function fail(){
    otp.classList.add('error');
    msg.classList.add('show');
    setTimeout(function(){ otp.classList.remove('error'); }, 450);
    inputs.forEach(function(i){ i.value=''; i.classList.remove('filled'); });
    inputs[0].focus();
  }

  function check(){
    if(value().length === 4){
      if(value() === CODE){ unlock(); }
      else { fail(); }
    }
  }

  inputs.forEach(function(inp, idx){
    inp.addEventListener('input', function(e){
      msg.classList.remove('show');
      var v = inp.value.replace(/[^0-9]/g,'');
      inp.value = v.slice(-1);
      inp.classList.toggle('filled', !!inp.value);
      if(inp.value && idx < inputs.length-1){ inputs[idx+1].focus(); }
      check();
    });
    inp.addEventListener('keydown', function(e){
      if(e.key === 'Backspace' && !inp.value && idx > 0){ inputs[idx-1].focus(); inputs[idx-1].value=''; inputs[idx-1].classList.remove('filled'); }
      if(e.key === 'Enter'){ check(); }
    });
    inp.addEventListener('paste', function(e){
      e.preventDefault();
      var data = (e.clipboardData || window.clipboardData).getData('text').replace(/[^0-9]/g,'').slice(0,4);
      inputs.forEach(function(b,k){ b.value = data[k] || ''; b.classList.toggle('filled', !!b.value); });
      (inputs[Math.min(data.length, inputs.length-1)]).focus();
      check();
    });
  });

  setTimeout(function(){ inputs[0].focus(); }, 200);
})();
